import { BookMarked } from "lucide-react";

export function WordStudy({ studies }) {
  if (!studies || studies.length === 0) return null;
  return (
    <div
      data-testid="word-study-block"
      className="mb-10 border border-[#D9D4CC] bg-[#FDFBF7] rounded-sm p-6 animate-fade-up"
    >
      <div className="flex items-center gap-2 mb-4">
        <BookMarked className="w-4 h-4 text-[#9B7E4E]" strokeWidth={1.75} />
        <p className="font-body text-sm uppercase tracking-[0.15em] text-[#7A756E]">
          The words you're decreeing
        </p>
      </div>
      <div className="space-y-5">
        {studies.map((s) => (
          <div key={s.word} data-testid={`word-study-${s.word}`}>
            <p className="font-heading text-xl text-[#2C2A29] capitalize">{s.word}</p>
            <ul className="mt-1.5 space-y-1.5">
              {s.entries.map((e) => (
                <li key={e.number} className="font-body text-sm text-[#4A4744] leading-relaxed">
                  <span className="font-decree text-base text-[#2C2A29]">{e.lemma}</span>{" "}
                  <span className="italic text-[#7A756E]">({e.translit})</span>{" "}
                  <span className="text-xs uppercase tracking-wide text-[#9B7E4E]">
                    {e.lang} · {e.number}
                  </span>
                  <span className="block text-[#4A4744]">{e.strongs_def}.</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
